export const FORCED_LANG: string | null = null
export const AHEAD_CONE_DEG = 75
export const MIN_MOVE_M = 15
export const GEO_LIMIT = 30

export const RADIO_MIN_INTERVAL_MS = 45_000
export const SPOKEN_CACHE_TTL_MS = 20 * 60_000
export const REJECT_CACHE_TTL_MS = 8 * 60_000

export const MAX_SPOKEN_CHARS = 750
export const POST_SPEECH_COOLDOWN_MS = 1500

export const FETCH_TIMEOUT_MS = 9000
export const FETCH_RETRIES = 2

export const OVERPASS_ENDPOINTS = [
  'https://overpass-api.de/api/interpreter',
  'https://overpass.kumi.systems/api/interpreter',
  'https://overpass.nchc.org.tw/api/interpreter',
]

export const USE_WIKIPEDIA = true
export const USE_OSM_WIKIDATA = true
export const USE_WIKIDATA_NATURE = true

export const SUPPORTED_LANGUAGES = [
  'nl',
  'en',
  'de',
  'fr',
  'es',
  'it',
  'pt',
  'sv',
  'da',
  'no',
] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_RADIUS_OPTIONS = [
  { value: 500, label: '500 m' },
  { value: 1000, label: '1 km' },
  { value: 1500, label: '1.5 km' },
  { value: 2000, label: '2 km' },
] as const

export const UNINTERESTING_KEYWORDS = [
  'sportvereniging',
  'sportclub',
  'voetbal',
  'hockey',
  'tennis',
  'korfbal',
  'handbal',
  'verzorgingsplaats',
  'verzorgingsplaatsen',
  'service area',
  'rest area',
  'aire',
  'tankstation',
  'benzine',
  'gas station',
  'parking',
  'parkeerplaats',
  'carpool',
  'mc donald',
  'mcdonald',
  'kfc',
  'burger king',
  'subway',
  'fysiotherapie',
  'tandarts',
  'apotheek',
  'huisarts',
]

export const NATURE_KEYWORDS = [
  'natuur',
  'bos',
  'heide',
  'duin',
  'veen',
  'polder',
  'rivier',
  'meer',
  'plas',
  'wetering',
  'kanaal',
  'dijk',
  'kade',
  'geul',
  'kwelder',
  'weide',
  'landgoed',
  'park',
  'moeras',
  'schans',
  'fort',
  'kasteel',
  'molen',
  'watertoren',
  'kerk',
  'ruïne',
  'ruine',
  'stuw',
  'sluis',
  'gemaal',
  'werf',
  'brug',
  'forest',
  'heath',
  'dune',
  'river',
  'lake',
  'canal',
  'polder',
  'nature',
  'reserve',
  'park',
  'wetland',
]
